import {
  COMPANY_DOCUMENT_PRIVACY_STATUS,
  type CompanyDocumentPermission,
  type CompanyDocumentPrivacyStatus,
} from '../../contracts/schemas/get-by-id.js';

const { PUBLIC, SHARED, SHARED_TO, SHARED_BY, PRIVATE, PRIVATE_REQUESTS } =
  COMPANY_DOCUMENT_PRIVACY_STATUS;

/**
 * How a document is shared, from `viewerCompanyId`'s point of view.
 *
 * Order matters: public wins over everything; any permission row beats the
 * owner/recipient comparison, and one approved row makes it `shared` where only
 * pending requests make it `private_requests`.
 */
export const buildPrivacyStatus = ({
  document,
  permissions,
  viewerCompanyId,
}: {
  document: {
    isPublic?: boolean | number | null;
    ownerCompanyId?: string | null;
    companyId?: string | null;
  };
  permissions: CompanyDocumentPermission[];
  viewerCompanyId: string;
}): CompanyDocumentPrivacyStatus => {
  if (document.isPublic) return { status: PUBLIC };

  if (permissions.length > 0) {
    const approvedRequests = permissions.filter(p => p.approvedAt).length;
    return {
      status: approvedRequests > 0 ? SHARED : PRIVATE_REQUESTS,
      requests: permissions.length,
      approvedRequests,
    };
  }

  if (document.ownerCompanyId === document.companyId) {
    return { status: PRIVATE };
  }
  if (document.ownerCompanyId === viewerCompanyId) {
    return { status: SHARED_TO };
  }
  return { status: SHARED_BY };
};
